import { Selector, createSelector } from 'reselect';
import { SessionManagementService } from '../../search/services/SessionManagementService';
import { AppUrls } from '../AppUrls';
import { Location } from '../../common/utils/Location';

export interface IUrlData {
  siteUrlName: string,
  queryString: string
}
const queryStringSelector = (): string => Location.search();
const siteUrlNameSelector = (data: IUrlData): string => data.siteUrlName;

const siteDataSelector: Selector<IUrlData, AppUrls> = createSelector(
  siteUrlNameSelector,
  queryStringSelector,
  (siteUrlName, queryString) => {
    return new AppUrls({ siteUrlName, queryString });
  }
);

export function appUrlsSelector(): AppUrls {
  return siteDataSelector({
    siteUrlName: SessionManagementService.instance.sessionSiteUrlName(),
    queryString: window.location.search
  });
}
